import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../commons/breadcrumb/breadcrumb";
import "./product.css";
import Button from "../../commons/button/button";
import ProductRowHeader from "./../../components/product-row-header/product-row-header";
import ProductTable from "../../commons/product_table/product_table";
import { useDispatch, useSelector } from "react-redux";
import { ProductAction } from "./../../action/product_action";
import {
  GlassMagnifier,
  MagnifierContainer,
  MagnifierPreview,
  MagnifierZoom,
} from "react-image-magnifiers";

const Product = ({ match, history }) => {
  const [sellBtn, setSellBtn] = useState("خرید");
  const [sellBtnToolTip, setSellBtnToolTip] = useState(
    "اضافه کردن به سبد خرید"
  );
  const [sellBtnBgColor, setSellBtnBgColor] = useState("#a5c926");

  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(ProductAction(match.params.id));
    checkExist();
  }, []);

  const { product } = useSelector((state) => state.product);
  const selectedProduct = product;
  const addToCartHandler = () => {
    history.push(`/cart/${match.params.id}`);
  };

  const checkExist = () => {
    const prID = match.params.id;
    const cartProducts = localStorage.getItem("cartItems")
      ? JSON.parse(localStorage.getItem("cartItems"))
      : [];
    console.log(prID, "prID");
    console.log(cartProducts, "cartProducts");
    cartProducts.map((item) => {
      if (item.product === prID) {
        setSellBtn("در سبد موجود است");
        setSellBtnToolTip("این محصول در سبد خرید شما موجود است");
        setSellBtnBgColor("#27ae60");
      }
    });
  };

  return (
    <Fragment>
      <div className="container-fluid product_page_body">
        <div className="container page_body">
          <Breadcrumb bread2="محصول" />
          <div className="product_body">
            <div className="row product_main_row">
              <div className="col-xs-12 col-sm-pull-12  col-sm-12 col-md-6 col-lg-6 col-xl-6 product_main">
                <h1 className="product_title">{selectedProduct.title}</h1>
                <p className="product_desc">{selectedProduct.desc}</p>
                <div className="product_price">
                  {selectedProduct.price}تومان
                </div>
                <div className="product_buttons_body">
                  {/* <div>
                    <input type="number" className="product_quantity" />
                  </div> */}
                  <div className="product_button" onClick={addToCartHandler}>
                    <Button
                      boxShadow="0px 0px 13px -3px #636e72"
                      background={sellBtnBgColor}
                      color="white"
                      heigh="50px"
                      width="180px"
                      radius="23px"
                      tooltip={sellBtnToolTip}
                      tooltiploc="bottom"
                    >
                      {sellBtn}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-push-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                {/* <img className="product_image" src={selectedProduct.image} /> */}

                <GlassMagnifier
                  imageSrc={selectedProduct.image}
                  imageAlt="آلت"
                  magnifierSize="50%"
                  magnifierBorderSize="10"
                />
              </div>
            </div>
            <div className="row product_detail_body">
              <ProductRowHeader Title="مشخصات محصول" />
            </div>
            <div className="row product_main_sec">
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 product_detail_table_body">
                <ProductTable />
              </div>
              <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 product_text">
                {selectedProduct.text}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Product;
